import "./styles.scss";

const Footer = () => {
  return (
    <div className="footer">
      <p>© 2024</p>
    </div>
  );
};

export default Footer;
